var IconButton_module_default = {
	"icon-button": "_icon-button_1215g_8",
	"no-background": "_no-background_1215g_42",
	destructive: "_destructive_1215g_95"
};
//#endregion
export { IconButton_module_default as default };

//# sourceMappingURL=IconButton.module.js.map